"use client"

import Image from 'next/image';
import kexpHost from "../../public/kexp-homepage-host-talking-1527x1017.webp";
import kexpLetters from "../../public/heroimage_landingpage copy.webp";
import { t } from "@lingui/core/macro";
import { Button } from '@heroui/react';
import { useRouter } from 'next/navigation';

export interface LandingPageCardProps {
    locale: string;
}

export default function LandingPageCard ({
    locale
} : LandingPageCardProps) {

    const router = useRouter();

    return(
        <div>
            <section className="relative">
                <div className="absolute inset-0 h-[650px] bg-black/60 z-10 sm:flex sm:flex-row sm:items-center">
                    <div className="relative max-w-5xl mx-auto mt-8 sm:mt-0 flex-1 sm:flex sm:flex-row sm:justify-between z-20">
                        <div className="bg-transparent px-4">
                            <h1 className="text-5xl text-kexp-light-layout-background font-black text-center">{t`You Power KEXP`}</h1>
                            <p className="mt-6 text-base px-6 sm:max-w-[450px] lg:max-w-[450px] text-kexp-light-layout-background font-semibold text-left">{t`And now there is a place for you to manage your support! Create a donor profile and update payment information in this brand new platform. More features coming soon!`}</p>
                        </div>
                        <div className="px-4 sm:max-w-[400px]">
                            <div className="relative mt-12 sm:mt-0 px-2 py-4 bg-white bg-opacity-100 opacity-100 rounded-lg border-2 border-kexp-light-default-300">
                                <h2 className="text-2xl font-black text-center mb-4">{t`Create a Donor Profile`}</h2>
                                <ol className="px-12 mb-6 list-decimal list-outside leading-relaxed">
                                    <li>{t`Sign up to create a secure profile with your donor email`}</li>
                                    <li>{t`Check your inbox for a link from KEXP`}</li>
                                    <li>{t`You're in!`}</li>
                                </ol>
                                <div className="w-full flex justify-center px-20">
                                    <Button
                                        className="rounded-full text-small font-normal text-white bg-kexp-light-primary-700 hover:bg-kexp-light-primary-800 transition-colors"
                                        onPress={() => router.push("/"+locale+"/signup")}
                                    >
                                        {t`Sign up now`}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Image
                    className="relative object-cover w-full min-h-[650px] max-h-[650px] z-0"
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    src={kexpLetters}
                    priority={true}
                    rel="preload"
                    alt={t`Image of KEXP studio signage`}
                >
                </Image>
                <div className="hidden sm:block absolute bottom-1 right-2 z-10 select-none">
                    <p className="text-xs text-white font-normal">{t`photo credit: Caroline Anne`}</p>
                </div>
            </section>
            <section className="my-16 sm:my-32">
                <div className='max-w-5xl mx-auto'>
                    <h1 className="sm:hidden text-4xl mt-6 mb-6 px-2 text-kexp-light-layout-foreground font-black text-center">{t`What is a Donor Profile?`}</h1>
                    <div className="px-4 sm:px-0 sm:hidden">
                        <Image
                            className="relative object-cover w-full"
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            src={kexpHost}
                            priority={true}
                            rel="preload"
                            alt={t`Image of KEXP host`}
                        >
                        </Image>
                    </div>
                    <div className="relative sm:flex sm:flex-row sm:justify-between mt-8 sm:mt-0">
                        <div className="bg-transparent px-4">
                            <h1 className="hidden sm:block sm:text-4xl sm:mb-6 sm:px-2 text-kexp-light-layout-foreground font-black text-center">{t`What is a Donor Profile?`}</h1>
                            <h2 className="px-6 text-3xl md:text-2xl text-kexp-light-layout-foreground font-semibold text-left">{t`Your KEXP Giving`}</h2>
                            <p className="mt-6 text-base px-6 sm:max-w-[450px] lg:max-w-[450px] text-kexp-light-layout-foreground font-normal text-left">{t`Log in to your profile to view your monthly Amplifier giving, update credit cards, see recent online donations and more.`}</p>
                            <h2 className="px-6 mt-6 text-3xl md:text-2xl text-kexp-light-layout-foreground font-semibold text-left">{t`Safe, Secure Updates`}</h2>
                            <p className="mt-6 text-base px-6 sm:max-w-[450px] lg:max-w-[450px] text-kexp-light-layout-foreground font-normal text-left">{t`The platform is built with secure industry best practices, and your payment information is transmitted securely to our credit card processor and not stored by KEXP.`}</p>
                        </div>
                        <div className="hidden sm:block px-4 sm:max-w-[300px] md:max-w-[400px] lg:max-w-[535px]">
                            <Image
                                className="relative object-cover w-full"
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                src={kexpHost}
                                priority={true}
                                rel="preload"
                                alt={t`Image of KEXP host`}
                            >
                            </Image>
                            <div className="hidden sm:block float-right pt-2 z-25">
                                <p className="text-xs text-black font-normal">{t`photo credit: Eric Tra`}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}